import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

axios.defaults.withCredentials = true;

export const getDataItem = async (requestUrl) => {
    // If requestUrl starts with / remove it
    let path = requestUrl.charAt(0) === '/' ? requestUrl : `/${requestUrl}`;

    const url = process.env.REACT_APP_CMS_API_PATH + path;
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;

    return await axios({ url, method: 'GET', headers: {
        'Authorization': `Bearer ${token}`
    } });
};
